import { IInventoryService } from './IInventoryService';
import { of as observableOf, Observable } from 'rxjs';
import { InventoryEntity } from '../../../models/Inventory/InventoryEntity';
import { HttpRequestService } from '../../http-request.service';
import {
  apiURLs,
  PREVILEGEKEY,
  InventoryTypeList,
  PackageType,
  InventoryCollectionType,
  InventoryLinkTypes
} from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FetchInventoryEntity } from '../../../models/Inventory/FetchInventoryEntity';
import { InventoryInquiryEntity } from '../../../models/Inventory/InventoryInquiryEntity';
import { InventoryCollectionEntity } from '../../../models/Inventory/InventoryCollectionEntity';
import { FilterListModel } from '../../../models/Utilities/FilterListModel';
import { PurchaseOrderHeaderEntity } from '../../../models/PurchaseOrder/PurchaseOrderHeaderEntity';
import { LinkedItemEntity } from '../../../models/LinkedItems/LinkedItemEntity';
import { Dictionary } from '../../Dictionary.Service';
import { InventoryBarCodeEntity } from '../../../models/Inventory/InventoryBarCodeEntity';
import { ClassesLookUpPost, InventoryLookupCollection, InventoryLookUpPost, LookupConfigurationV2, SupplierItemLookUpPost } from 'src/app/shared/models/Inventory/InventoryLookUpEntity';

@Injectable({
  providedIn: 'root'
})
export class InventoryService implements IInventoryService {
  constructor(private httpService: HttpRequestService) { }

  /* Fetches the inventory details. */
  GetInventory(FetchModel: FetchInventoryEntity): Observable<InventoryInquiryEntity[]> {

    return this.httpService.GetHttpRequestId(FetchModel, apiURLs.InventoryAPI.GetInventory);

  }

  GetUnitTypes(filterQuery){
    return this.httpService.GetHttpRequest(apiURLs.TransactionManagement.UnitType + filterQuery).toPromise();
  }

  getUnitList(filterQuery){
    return  this.httpService.GetHttpRequest(`/inventory/api/units?` + filterQuery).toPromise()
  }

  /* Search Column = name (or) number (or) barcode. */
  SearchInventory(searchValue: string): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('searchValue', searchValue.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.SearchInventory);

  }

  /* GET Inventory Status By Location */
  GetInventoryStatusByLocation(siteId: number, inventoryId: number[], loadFrom: number): Observable<InventoryEntity[]> {

     const inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('inventoryId', inventoryId.join(',').toString())
      .set('loadFrom', loadFrom.toString())
      .set('APIKEY', PREVILEGEKEY.GetInventoryStatusbyLocation);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryStatusByLocation);

  }

  /* Gets Inventory Usage Details */
  GetInventoryUsageStatus(siteId: number, inventoryId: number, sourceId: number = 0): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('inventoryId', inventoryId.toString())
      .set('sourceId', sourceId.toString())
      .set('APIKEY', PREVILEGEKEY.GetInventoryUsageStatus);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryUsageStatus);

  }

  /* Gets Inventory Purchase Details */
  GetInventoryPurchaseStatus(siteId: number, inventoryId: number): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('inventoryId', inventoryId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryPurchaseStatus);
  }

  /* Gets Inventory Type Details */
  GetInventoryTypes(inventoryTypeList: InventoryTypeList): Observable<InventoryCollectionEntity[]> {
    const inputParams = new HttpParams().set('inventoryTypeList', JSON.stringify(inventoryTypeList));
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryTypes);
  }

  /* Gets Inventory Class Details */
  GetInventoryClass(inventoryTypeList: InventoryTypeList): Observable<InventoryCollectionEntity[]> {

    return this.httpService.GetHttpRequestId(inventoryTypeList, apiURLs.InventoryAPI.GetInventoryClass);
  }

  /* Gets Inventory Package Details. packType :Inventory = 1, Receipe = 2,Equipment = 3,Customer = 5, Supplier = 6,Product = 7 */
  GetInventoryPackage(packType: PackageType, siteId: number): Observable<InventoryCollectionEntity[]> {
    const inputParams = new HttpParams().set('packType', JSON.stringify(packType))
      .set('siteId', siteId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryPackage);
  }

  /**
   * @version 13.2 UI
   * @param collectionType
   * @param siteId
   * @param typeId
   * @param supplyLocationId
   * @returns
   */
  /* Gets Inventory Package Details. packType :Inventory = 1, Receipe = 2,Equipment = 3,Customer = 5, Supplier = 6,Product = 7 */
  GetPackageList(packageQueryParams: any): Observable<any> {
    const PackageUrl = apiURLs.InvertoryManagement.GetPackage + packageQueryParams;
    return this.httpService.GetHttpRequest(PackageUrl);
  }
  // GetClassList(packageQueryParams: any): Observable<any> {
  //   const PackageUrl = apiURLs.InvertoryManagement.GetClasses + packageQueryParams;
  //   return this.httpService.GetHttpRequest(PackageUrl);
  // }

  GetClassesTypesPackages(LookupModel: ClassesLookUpPost ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetClassesTypesPackages, LookupModel);
  }
  SearchBySupplierItemNumber (LookupModel: SupplierItemLookUpPost): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.SearchBySupplierItemNumber, LookupModel);
  }
  GetTypes(packageQueryParams: any): Observable<any> {
    const PackageUrl = apiURLs.InvertoryManagement.GetTypes + packageQueryParams;
    return this.httpService.GetHttpRequest(PackageUrl);
  }

  GetProductList(productQueryParams: any): Observable<any> {
    const ProductUrl = apiURLs.InvertoryManagement.GetProduct + productQueryParams;
    return this.httpService.GetHttpRequest(ProductUrl);
  }

  /* Gets Inventory Type,Class and Package Item Details */
  GetInventoryCollectionDetails(collectionType: InventoryCollectionType,
     siteId: number, typeId: number[], supplyLocationId: number = 0): Observable<InventoryCollectionEntity[]> {

    const inputParams = new HttpParams().set('collectionType', JSON.stringify(collectionType))
      .set('siteId', siteId.toString())
      //  .set('locationId', locationId.toString())
      .set('typeId', JSON.stringify(typeId.toString()))
      .set('typeId', typeId.toString())
      .set('supplyLocationId', supplyLocationId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryCollectionDetails);
  }

  /* Gets Receipe Type,Class and Package Item Details */
  GetRecipeCollectionDetails(collectionType: InventoryCollectionType,
     siteId: number, locationId: number, typeId: number[]): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('collectionType', JSON.stringify(collectionType))
      .set('siteId', siteId.toString())
      .set('locationId', locationId.toString())
      .set('typeId', typeId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetRecipeCollectionDetails);
  }

  /* Gets Product Type,Class and Package Item Details */
  GetProductCollectionDetails(collectionType: InventoryCollectionType,
     siteId: number, locationId: number, typeId: number[]): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('collectionType', JSON.stringify(collectionType))
      .set('siteId', siteId.toString())
      .set('locationId', locationId.toString())
      .set('typeId', typeId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetProductCollectionDetails);
  }

  /* Gets Inventory Zoom Details */
  // GetInventoryZoom(siteId: number, inventoryId?: number, filterModel?: FilterListModel): Observable<InventoryEntity[]> {

  //  let inputParams = new HttpParams().set('siteId', siteId.toString())
  //    .set('inventoryId', inventoryId.toString())
  //    .set('filterModel', JSON.stringify(filterModel.toString()));

  //  return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryZoom);

  // }
  GetInventoryZoom(siteId: number, inventoryId?: number): Observable<InventoryEntity[]> {

    const inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('inventoryId', inventoryId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryZoom);

  }
  /*  Gets Inventory Bids Details by inventory id*/
    GetInventoryBidDetails(inventoryId: number): Observable<InventoryEntity[]> {
    const inputParams = new HttpParams().set('inventoryId', inventoryId.toString())
    .set('APIKEY', PREVILEGEKEY.GetInventoryBidDetails);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryBidDetails);
  }

  /* Fetches the inventory details. */
  GetInventorySummary(siteId: number, searchValue: string): Observable<InventoryEntity[]> {
    const inputParams = new HttpParams().set('SiteId', siteId.toString())
      .set('SearchValue', searchValue);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventorySummary);
  }
  /**
   * @version 13.2 UI
   * @method GetInventoryLookUp
   * @param LookupModel
   * @returns
   */
  GetInventoryLookUp(LookupModel: InventoryLookUpPost ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetInventoryLookup, LookupModel);
  }

  GetInventoryLookUpV2(LookupModel: LookupConfigurationV2 ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetInventoryLookupV2, LookupModel);
  }

  /**
   * @version 13.4 UI
   * @method GetBinInventoryLookUp
   * @param LookupModel
   * @returns
   */
  GetBinInventoryLookUp(LookupModel: InventoryLookUpPost ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetAllBinUtilitiesByBinItemNumber, LookupModel)
  }

  /**
   * @version 13.4 UI
   * @method GetLotInventoryLookUp
   * @param LookupModel
   * @returns
   */
  GetLotInventoryLookUp(LookupModel: InventoryLookUpPost ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetAllLotsByLotId, LookupModel)
  }

    /**
   * @version 13.4 UI
   * @method GetLotInventoryLookUp
   * @param LookupModel
   * @returns
   */
  GetBatchInventoryLookUp(LookupModel: InventoryLookUpPost ): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetConsignmentItemLookup, LookupModel)
  }

  GetInventorySearch(InventorySearchParam: any ): Observable<any> {
    const requestUrlParams = apiURLs.InvertoryManagement.GetIngredients + InventorySearchParam;
    return this.httpService.GetHttpRequest(requestUrlParams);
  }

  /* Gets Inventory details */
  GetInventoryDetails(transType: number, siteId: number, itemId: number[], apiKey = '',
     toLocation: number = 0, supplyLocation: number = 0, bidInputs: string = 'NA'): Observable<InventoryEntity[]> {

    // let inputParams = new HttpParams().set('transType', transType.toString())
    //  .set('siteId', siteId.toString())
    //  .set('itemId', itemId.join(',').toString())
    //  .set('toLocation', toLocation.toString())
    //  .set('supplyLocation', supplyLocation.toString())
    //  .set('bidInputs', bidInputs.toString());
    // return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryDetails);
    const inputParams = {
      'transType': transType.toString(),
      'siteId': siteId.toString(),
      'itemId': itemId.join(',').toString(),
      'toLocation': toLocation.toString(),
      'supplyLocation': supplyLocation.toString(),
      'bidInputs': bidInputs.toString(),
      'APIKEY': null
    };
    if (apiKey !== '') {
      inputParams.APIKEY = apiKey;
    }
    return this.httpService.postHttpRequest(apiURLs.InventoryAPI.GetInventoryDetails, inputParams);
  }

  GetInventoyDetail(itemId: number){
    const requestUrl = apiURLs.InvertoryManagement.GetInventory + itemId;
    return this.httpService.GetHttpRequest(requestUrl);
  }

  /* Gets Barcode details */
  GetInventoryBarcodeDetails(itemId: number[]): Observable<InventoryBarCodeEntity[]> {
    const inputParams = { 'itemId': itemId, 'APIKEY' : PREVILEGEKEY.GetInventoryBarcodeDetails };
    return this.httpService.postHttpRequest(apiURLs.InventoryAPI.GetInventoryBarcodeDetails, inputParams.itemId);
  }

  GetInventoryPurchaseOrders(siteId: number, itemId: number): Observable<PurchaseOrderHeaderEntity[]> {
    const inputParams = new HttpParams()
    .set('siteId', siteId.toString())
    .set('itemId', itemId.toString())
    .set('APIKEY', PREVILEGEKEY.GetInventoryPurchaseOrders);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryPurchaseOrders);
  }

  GetInventoryLinkItems(inventoryLinkTypes: InventoryLinkTypes, siteId: number, itemId: number): Observable<LinkedItemEntity> {
    const inputParams = new HttpParams().set('inventoryLinkTypes', inventoryLinkTypes.toString()).set('siteId', siteId.toString()).set('itemId', itemId.toString()).set('APIKEY', PREVILEGEKEY.GetInventoryLinkItems);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.InventoryAPI.GetInventoryLinkItems);
  }

  
  /**
   * get barcodes
   * @version 13.2 
   * @param 
   * @returns 
   */
   GetIngredientsBarcodes(params: any): Observable<any> {
    const ingredientsUrl = apiURLs.InvertoryManagement.GetIngredientsBarcodes + params
    return this.httpService.GetHttpRequest(ingredientsUrl); 
  }

   /**
    * add barcodes
   * @version 13.2
   * @param 
   * @returns 
   */
    PostIngredientsBarcodes(params: any): Observable<any> {
      const ingredientsUrl = apiURLs.InvertoryManagement.PostIngredientsBarcodes
      return this.httpService.postHttpRequest(ingredientsUrl, params); 
    }
}
